import {
  BaseRequestInterface, BaseResponseInterface
} from '@interface/public';
import { AxiosAPI } from '@server/_axios';

const apiPath = { // API地址
  store: 'website/market/apps/', // 商城
  user: 'website/api/v1/' // 用户
};

//----- 获取横幅列表 Start -----//
interface Banner {
  id: string; // 唯一标识
  title: string; // 标题
  content: string; // 内容
  bg_image: string; // 背景图片链接
  is_top: boolean; // 是否置顶，同时最多只能有一个生效的置顶 banner
  button_text: string; // 按钮文本
  button_text_color: string; // 按钮文本颜色
  button_bg_color: string; // 按钮背景色
  button_url: string; // 点击跳转地址
  publish: boolean; // 是否发布
  created_at: number; // 创建时间（时间戳）
  updated_at: number; // 更新时间（时间戳）
}
export interface RequestBannerList extends BaseRequestInterface {

}
export interface ResponseBannerList extends BaseResponseInterface {
  data:Banner[]; 
}
export async function AxiosBannerList(params: RequestBannerList): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.user }market_banner/list`,
    params 
  })
}

//----- 获取横幅列表 End   -----//